import moment from 'moment';
import "moment-timezone";
import React, { Component } from "react";
import { Link } from 'react-router-dom';
import SRFlags from '../SeminarRegistrations/Flags';
import PhoneNumber from '../Shared/PhoneNumber';
import TCSFlags from '../TCS/Flags';
import Flags from './Flags';

class DealTable extends Component {
  constructor(props) {
    super(props);
    this.state = { items: props.items };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setState({ items: this.props.items })
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.items === prevState.items
      ? {}
      : { items: nextProps.items };
  }

  handleSelectChange = (event, id) => {
    const checked = event.target.checked;
    this.changeSelectedState(id, checked)
  }

  changeSelectedState = (id, checked) => {
    this.props.itemSelectStateChanged(id, checked)
  }

  handleSelectAllChange = (event) => {
    if (this.state.checkedSelectAll) {
      this.props.itemSelectAllChanged(false)
      this.setState({ checkedSelectAll: false })
    } else {
      this.props.itemSelectAllChanged(true)
      this.setState({ checkedSelectAll: true })
    }
  }

  render() {
    const DealTable = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <DealTableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
              view={props.view}
            />
          ))}
        </tbody>
      );
    };

    const DealTableHeader = props => {
      return (
        <thead className='dark'>
          <tr>
            {this.props.itemSelectStateChanged && <th style={{ width: 10 }}><input type="checkbox" checked={this.state.checkedSelectAll} onChange={this.handleSelectAllChange} /></th>}
            <th style={{ width: 40 }}>ID</th>
            <th>Parent Email</th>
            <th>Parent Name</th>
            <th>Parent Mobile</th>
            <th>Status</th>
            {props.view === 'on_hold' && <th>On Hold</th>}
          </tr>
        </thead>
      );
    };

    const DealTableItem = props => {
      const deal = props.item
      return (
        <tr>
          <td data-label="Select">
            {this.props.itemSelectStateChanged && <input style={{ marginRight: 10 }} type="checkbox" checked={deal.isSelected} onChange={(event) => this.handleSelectChange(event, deal.id)} />}
          </td>
          <td data-label="ID">
            <Link to={`/m1/deals/${deal.id}`} style={{ whiteSpace: 'nowrap' }}>Deal #{deal.id}</Link>
          </td>
          <td data-label="Email"><Link to={`/m1/contacts/${deal.contact_id}`}>{deal.email}</Link></td>
          <td data-label="Parent">
            {deal.first_name} {deal.last_name}
          </td>
          <td data-label="Mobile" style={{ whiteSpace: "nowrap" }}>
            <PhoneNumber number={deal.mobile}></PhoneNumber>
          </td>
          <td data-label="Deal Status">
            <SRFlags deal={deal} prefix="Registration: " />
            <TCSFlags deal={deal} prefix='TCS: ' />
            <Flags deal={deal} prefix='Deal: ' />
          </td>
          {props.view === 'on_hold' && <td>
            <p>On Hold by {deal.on_hold_by}<br />Until {moment(deal.on_hold_until).format("DD MMM YYYY h:mm a")}</p>
            {deal.on_hold_reason && <p>
              {deal.on_hold_reason.split('\n').map((item, key) => {
                return <span key={key}>{item}<br /></span>
              })}
            </p>}
          </td>}
        </tr>
      );
    };
    return (
      <div>
        <table
          className="table table-hover table-bordered stable-condensed responsive"
          style={{ width: "100%" }}
        >
          <DealTableHeader view={this.props.view} />
          <DealTable items={this.state.items} view={this.props.view} />
        </table>
      </div>
    );
  }
}

export default DealTable;
